import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["value"]

import { ref, computed, watch } from 'vue'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScoringVotesSourceSelectorDialog',
  props: {
    propOpened: { type: Boolean },
    propDefaultSurveyId: {},
    propDefaultProjectUserId: {},
    propSurveys: {},
    propProjectUsers: {}
  },
  emits: ["load-panelists", "confirm-selection", "close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- derived props ---------------- */

    const opened = computed(() => props.propOpened)
    const defaultSurveyId = computed<number | null>(() => props.propDefaultSurveyId ?? null)
    const defaultProjectUserId = computed<number | null>(() => props.propDefaultProjectUserId ?? null)

    const surveys = computed(() => props.propSurveys)
    const projectUsers = computed(() => props.propProjectUsers)

    /* ---------------- local state ---------------- */

    const surveyId = ref<number | null>(null)
    const projectUserId = ref<number | null>(null)

    /* ---------------- watchers ---------------- */

    // replaces @Watch('opened')
    watch(opened, (val) =>
    {
        if (val === true)
        {
            surveyId.value = defaultSurveyId.value
            projectUserId.value = defaultProjectUserId.value
        }
    })

    // replaces @Watch('surveyId')
    watch(surveyId, (val) =>
    {
        if (val != null)
        {
            projectUserId.value = null
            emit('load-panelists', val)
        }
    })

    /* ---------------- actions ---------------- */

    function confirm()
    {
        emit('confirm-selection', surveyId.value, projectUserId.value)
    }

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Evaluation", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", null, "Panel:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((surveyId).value = $event)),
                    class: "form-control"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveys.value, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: s.Id
                      }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_7))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, surveyId.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", null, "Respondent:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projectUserId).value = $event)),
                    class: "form-control"
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "Aggregated", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectUsers.value, (p) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: p.Id
                      }, _toDisplayString(p.Name), 9 /* TEXT, PROPS */, _hoisted_9))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, projectUserId.value]
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: confirm,
                  class: "btn btn-success"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})